import { forwardRef } from 'react'
import Input from './Input'
const SearchInput = forwardRef(function SearchInput({ className = '', ...props }, ref) {
    return <Input type="search" {...props} ref={ref} className={'uiSearchInput ' + className} />
})
SearchInput.uiField = true
export default SearchInput
